export default __webpack_public_path__ + "static/media/tax-saving-icon.4a4e9408.svg";